import { FC } from 'react'
import { stencil } from 'react-common'
import { useAppSelector } from '@/store/hooks'

const { ContentHeaderRightSlotPlugin } = stencil

export const ContentHeaderPreset: FC = () => {
  const isContentHeaderPluginVisible = useAppSelector((state) => state.contentHeaderPlugin.pluginEnabled)

  const rightSlot = useAppSelector((state) => state.contentHeaderPlugin.rightSlot)

  if (!isContentHeaderPluginVisible) return null
  return <ContentHeaderRightSlotPlugin>{rightSlot}</ContentHeaderRightSlotPlugin>
}
